import React from 'react';
import PropTypes from 'prop-types';

const TreeSelect = props => {
  const {
    value,
    onChange,
    valueKey,
    labelKey,
    subOptionsKey,
    selectableKey,
    options,
    selectablePredicate,
  } = props;
  return (
    <ul className="TreeSelect">
      {options.map(option => {
        const selectable = selectableKey ? option[selectableKey] : selectablePredicate(option);
        const checked = value === option[valueKey];
        return (
          <li key={option[valueKey]} className={checked ? 'checked' : 'unchecked'}>
            <span
              className={selectable ? 'selectable' : ''}
              onClick={selectable ? e => onChange(option[valueKey]) : null}
            >
              {option[labelKey]}
            </span>
            {option[subOptionsKey] && <TreeSelect {...props} options={option[subOptionsKey]} />}
          </li>
        );
      })}
    </ul>
  );
};

TreeSelect.displayName = 'TreeSelect';

TreeSelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  subOptionsKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  selectableKey: PropTypes.string,
  selectablePredicate: PropTypes.func,
};

TreeSelect.defaultProps = {
  subOptionsKey: 'subOptions',
  labelKey: 'label',
  valueKey: 'value',
  selectablePredicate: () => true,
};

export default TreeSelect;
